import { AdvertiserForm } from 'components/advertisers'
import { useQueryAdvertiser } from 'hooks/advertisers'
import { useParams } from 'react-router-dom'
import { useAppTranslation } from 'hooks/useTranslation'

export const EditAdvertiser = () => {
  const { id } = useParams()
  const { t } = useAppTranslation()

  const { isLoading, isError, error, advertiser } = useQueryAdvertiser({
    id: id!,
  })

  if (isLoading) {
    return <div>{t('common.loading')}</div>
  }

  if (isError) {
    return (
      <div>
        {t('common.error')}: {error?.message}
      </div>
    )
  }

  if (!advertiser) {
    return <div>Advertiser not found</div>
  }

  return <AdvertiserForm advertiser={advertiser} />
}